import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PAGE_PATHS, Permission } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/')({
  validateSearch: zodValidator(withDefaults(schema.MODEL_MANAGEMENT, defaultFilter)),
  beforeLoad: ({ context, preload }) => {
    const path = PAGE_PATHS.MODEL_MANAGEMENT;
    const isId = window.location.pathname.split('/').at(-1) === '$id';
    const isAllowed =
      context.userPermissions.hasAllowedPermission({ path }) ||
      (isId && context.userPermissions.hasAllowedPermission({ path, permission: Permission.UPDATE }));
    context.validatePermissions({ isAllowed, preload });
  },
});
